export const formatMobile = (mobile) => {
  if (!mobile) return "";
  
  // Strip everything except digits and the plus sign
  let cleaned = mobile.toString().replace(/[^\d+]/g, "");

  // Handle +92
  if (cleaned.startsWith("+92")) {
    return "0" + cleaned.substring(3);
  }
  
  // Handle 0092
  if (cleaned.startsWith("0092")) {
    return "0" + cleaned.substring(4);
  }

  // Handle 92 (without plus or 00)
  if (cleaned.startsWith("92") && (cleaned.length === 12 || cleaned.length === 11)) {
    return "0" + (cleaned.length === 12 ? cleaned.substring(2) : cleaned.substring(2));
  }

  // If it's already 03... just return it
  if (cleaned.startsWith("03") && cleaned.length === 11) {
    return cleaned;
  }

  // Fallback for other formats - if it's 10 digits and seems like a local number, add 0
  if (cleaned.length === 10 && (cleaned.startsWith("3"))) {
    return "0" + cleaned;
  }

  return cleaned;
};

export const normalizeMobile = (mobile) => {
  if (!mobile) return "";
  const cleaned = mobile.toString().replace(/[^\d]/g, "");
  if (cleaned.startsWith("03") && cleaned.length === 11) {
    return "+92" + cleaned.substring(1);
  }
  if (cleaned.startsWith("3") && cleaned.length === 10) {
    return "+92" + cleaned;
  }
  return mobile;
};

export const formatCNIC = (cnic) => {
  if (!cnic) return "";
  let cleaned = cnic.toString().replace(/[^\d]/g, "");
  if (cleaned.length > 5) {
    cleaned = cleaned.substring(0, 5) + "-" + cleaned.substring(5);
  }
  if (cleaned.length > 13) {
    cleaned = cleaned.substring(0, 13) + "-" + cleaned.substring(13, 14);
  }
  return cleaned.substring(0, 15);
};

export const normalizeCNIC = (cnic) => {
  if (!cnic) return "";
  return cnic.toString().replace(/[^\d-]/g, "");
};
